<div class="item" *transloco="let t">
    <span class="title">{{t(this.itemData.title)}}</span>
    <button mat-flat-button color="primary" *ngIf="!this.itemData?.url" (click)="prepareDownload(itemData)" [disabled]="disableButton">
        <nb-icon icon="cloud-download-outline"></nb-icon>
        <span>{{t('download-report')}}</span>
    </button>
    <button mat-stroked-button color="primary" *ngIf="this.itemData?.url" (click)="openLink()" [disabled]="disableButton">
        <nb-icon icon="diagonal-arrow-right-up-outline"></nb-icon>
        <span>{{t('download-report')}}</span>
    </button>
</div>
    